import { notification } from 'redux-store/reducers/common-reducer';
import store from 'redux-store/store';

export function dispatchWithShameNotificationAction(...params) {
  if (!store) {
    return;
  }

  store.dispatch(notification(...params));
}
